export default function authHeader() {
  const staff = JSON.parse(localStorage.getItem('staff'));

  if (staff && staff.accessToken) {
    return { Authorization: 'Bearer ' + staff.accessToken };
  } else {
    return {};
  }
}
